 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		30: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		30: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-live-blog~faa4c18a","1":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-live-blog~4286d53b","2":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-live-blog~db11b463","3":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-live-blog~7721c579","4":"footer_1~footer_2~footer_3~header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-he~2c9e60d9","5":"vendors~header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-header_2~single-layer~2cb341c2","6":"StoryTemplateChunkstory-templates-snapshot~list~story","7":"StoryTemplateChunkstory-templates-listicle-story","8":"StoryTemplateChunkstory-templates-live-blog","9":"StoryTemplateChunkstory-templates-photo-story","10":"StoryTemplateChunkstory-templates-snapshot","11":"StoryTemplateChunkstory-templates-text-story","12":"StoryTemplateChunkstory-templates-video-story","13":"StoryTemplateChunkstory-templates-visual-story","14":"StoryTemplateChunkstory-templates-other","15":"StoryTemplateChunkstory-templates-photo-story-story-selectors","16":"StoryTemplateChunkstory-templates-story-selectors","17":"StoryTemplateChunkstory-templates-text-story-story-selectors","18":"StoryTemplateChunkstory-templates-video-story-story-selectors","19":"vendors~firebase-app~firebase-messaging","20":"SSOWrapperBase","21":"SidebarTemplate","22":"StoryTemplateChunkstory-templates-blank-m-css","23":"StoryTemplateChunkstory-templates-listicle-story-listicle-m-css","24":"StoryTemplateChunkstory-templates-live-blog-live-blog-module-css","25":"StoryTemplateChunkstory-templates-photo-story-photo-module-css","26":"StoryTemplateChunkstory-templates-snapshot-snapshot-m-css","27":"StoryTemplateChunkstory-templates-text-story-text-story-m-css","28":"StoryTemplateChunkstory-templates-video-story-video-m-css","29":"StoryTemplateChunkstory-templates-visual-story-visual-story-m-css","31":"firebase-app","33":"footer_1","34":"footer_2","35":"footer_3","36":"glide","37":"header_1","38":"header_2","39":"header_3","40":"header_4","41":"list","42":"metypeFeedWidget","44":"qtc-react-pdf","45":"secret-mode","47":"single-layer-header_1","48":"single-layer-header_2","49":"single-layer-header_3","50":"single-layer-header_4","51":"single-layer-header_5","52":"story","53":"subscription","54":"vendors~firebase-messaging","55":"vendors~glide","56":"vendors~list","57":"vendors~pdfjsWorker","58":"vendors~qtc-react-pdf","59":"vendors~qtc-react-youtube","60":"vendors~secret-mode"}[chunkId]||chunkId) + "-" + "780bd3348f858387a4c5" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"4":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"45":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"56":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-live-blog~faa4c18a","1":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-live-blog~4286d53b","2":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-live-blog~db11b463","3":"vendors~StoryTemplateChunkstory-templates-listicle-story~StoryTemplateChunkstory-templates-live-blog~7721c579","4":"footer_1~footer_2~footer_3~header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-he~2c9e60d9","5":"vendors~header_1~header_2~header_3~header_4~single-layer-header_1~single-layer-header_2~single-layer~2cb341c2","6":"StoryTemplateChunkstory-templates-snapshot~list~story","7":"StoryTemplateChunkstory-templates-listicle-story","8":"StoryTemplateChunkstory-templates-live-blog","9":"StoryTemplateChunkstory-templates-photo-story","10":"StoryTemplateChunkstory-templates-snapshot","11":"StoryTemplateChunkstory-templates-text-story","12":"StoryTemplateChunkstory-templates-video-story","13":"StoryTemplateChunkstory-templates-visual-story","14":"StoryTemplateChunkstory-templates-other","15":"StoryTemplateChunkstory-templates-photo-story-story-selectors","16":"StoryTemplateChunkstory-templates-story-selectors","17":"StoryTemplateChunkstory-templates-text-story-story-selectors","18":"StoryTemplateChunkstory-templates-video-story-story-selectors","19":"vendors~firebase-app~firebase-messaging","20":"SSOWrapperBase","21":"SidebarTemplate","22":"StoryTemplateChunkstory-templates-blank-m-css","23":"StoryTemplateChunkstory-templates-listicle-story-listicle-m-css","24":"StoryTemplateChunkstory-templates-live-blog-live-blog-module-css","25":"StoryTemplateChunkstory-templates-photo-story-photo-module-css","26":"StoryTemplateChunkstory-templates-snapshot-snapshot-m-css","27":"StoryTemplateChunkstory-templates-text-story-text-story-m-css","28":"StoryTemplateChunkstory-templates-video-story-video-m-css","29":"StoryTemplateChunkstory-templates-visual-story-visual-story-m-css","31":"firebase-app","33":"footer_1","34":"footer_2","35":"footer_3","36":"glide","37":"header_1","38":"header_2","39":"header_3","40":"header_4","41":"list","42":"metypeFeedWidget","44":"qtc-react-pdf","45":"secret-mode","47":"single-layer-header_1","48":"single-layer-header_2","49":"single-layer-header_3","50":"single-layer-header_4","51":"single-layer-header_5","52":"story","53":"subscription","54":"vendors~firebase-messaging","55":"vendors~glide","56":"vendors~list","57":"vendors~pdfjsWorker","58":"vendors~qtc-react-pdf","59":"vendors~qtc-react-youtube","60":"vendors~secret-mode"}[chunkId]||chunkId) + "-" + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"69a33ad9f0431d916b6c","3":"31d6cfe0d16ae931b73c","4":"213da90d52914217d432","5":"31d6cfe0d16ae931b73c","6":"9823653e60012e8cd568","7":"ae77575cd38d1793fbf6","8":"ebf3a2fc297532637600","9":"c1519ea2a77f96ef2ed4","10":"0babbf12917da0aae216","11":"67f96ec50141279b43e5","12":"511223b1ad86d4fa4707","13":"f799230e6eae96721128","14":"3fbc3fb41d8e2d79cead","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"fe802553e8514d756961","21":"3a48db6f0391e03de3a4","22":"775be5d7b6c5f5605d5f","23":"95b2cbf285219fe7d91d","24":"2132436ee81980934737","25":"988b6694669bf0200dfe","26":"0c35b421194883ac71c1","27":"5565eb6b3e06bfa1c66b","28":"443c56e50d33bb6b440d","29":"1a35dbe55fc5adce6eec","31":"31d6cfe0d16ae931b73c","33":"df59940c006af610a31c","34":"2ff107f64d1e60b1456c","35":"fadf355f2260ec6f386d","36":"5601a62b777eb193927d","37":"6a05925129e098a6cd92","38":"8e861cf3f4abeb09dbd5","39":"d2a1fff9efc54d4d0492","40":"829b0f014a8e936d7a58","41":"3ea9395179578b3906c5","42":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"499d1826a1fbbe7088dc","47":"b123f6a6e3febd9fcb24","48":"2b1b9c287bcc61a4ff8b","49":"020caad794c030548939","50":"53be148dd306682eec6c","51":"53ca82f1f9fc72f2859a","52":"73168567cc9e1859e433","53":"11a71acdf2e350311acd","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"33e405fab116fd98b1fa","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// chunk preloadng for javascript

 		var chunkPreloadMap = {
 			"52": [
 				0,
 				1,
 				2,
 				3,
 				7,
 				8,
 				14,
 				9,
 				11,
 				12,
 				22,
 				23,
 				24,
 				25,
 				15,
 				16,
 				17,
 				27,
 				18,
 				28,
 				13,
 				29
 			]
 		};

 		var chunkPreloadData = chunkPreloadMap[chunkId];
 		if(chunkPreloadData) {
 			chunkPreloadData.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					link.charset = 'utf-8';
 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "preload";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/quintype-ace/assets/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 189);
